import Receiver from '../Interface/Receiver';
import string_table from '../Interface/StringTable.js';
import {
	redirectToGroupScreen, redirectToDashboardScreen, redirectToScenesScreen, redirectToReportScreen,
	redirectToGuestRoomScreen
} from '../Components/Common/navigation.js';
import { isEmpty } from '../Components/Common/Common.js';
//For encryption
const NodeRSA = require('node-rsa');

export default class App_Receiver extends Receiver {
	constructor(props) {
		super();
		// App model is the model of the mobile app. 
		// F = 'ReiriOffice'
		// H = 'ReiriHome'

		this.app_model = 'F';

		this.app_version = "1.1.15";
		// The allowed models to connect to. Reiri Home and Office are different.
		this.allowed_models = {};
		this.allowed_models.office = ['F01', 'F04', 'F05', 'F06BR', 'F10', 'L01', 'R01'];
		this.allowed_models.home = ['H01', 'H02'];

		// To store the next component to render (i.e. what is the next screen)
		this.next_component = '';
		// for storing params temporarily before passing to next screen
		// i.e. if more than 1 set of data required for screen, can store temporarily before getting the next set of data
		// Eg. screens like Interlock or Schedule
		// Note: Remember to set to {} empty json after use
		this.stored_params = {};

		// To check if connection attempt is via reconnection, if true and log in successful, do not go to Dashboard
		this.is_using_reconnection = false;

		// To keep track of existing errors during login thrown by controller. Should reset everytime on login
		this.existing_login_error = '';

		// For Comm Module to keep track if controller is found during reconnection
		this.reconnect_controller_found = false;
	}

	getRSAKeyPair() {
		if (window.localStorage) {
			if (window.localStorage.getItem('private_key') != null && window.localStorage.getItem('public_key') != null) {
				this.public_key = window.localStorage.getItem('public_key');
				this.private_key = window.localStorage.getItem('private_key');
			} else {
				/*
				 * For RSA Encrytion
				 */
				const key = new NodeRSA();
				// create RSA private and public key
				key.generateKeyPair();
				this.public_key = key.exportKey('pkcs1-public-pem');
				this.private_key = key.exportKey('pkcs1-private-pem');
				// to create keys take long time so it should store in App and use stored keys
				this.common_key = '';

				window.localStorage.setItem('private_key', this.private_key);
				window.localStorage.setItem('public_key', this.public_key);
			}
		}
	}

	login(user) {
		if (window.app) window.app.showLoading();
		this.existing_login_error = '';
		super.login(user);
	}

	setLanguage(language_setting) {
		super.setLanguage(language_setting);
		window.localStorage.setItem('language', language_setting.lang);
	}

	logout() {
		super.logout();
		window.app.hideLoading();
		this.is_using_reconnection = false;
		// Change the is_logged_in status in local storage
		// this is to stop auto login
		let controller_name = this.active_controller.name;
		let controller_info = JSON.parse(window.localStorage.getItem(controller_name));
		if (controller_info != null && controller_info != undefined) {
			controller_info.is_logged_in = false;
		}
		window.localStorage.setItem(controller_name, JSON.stringify(controller_info));

		// Set MSM mode to false
		if (window.app.state.is_msm_mode) window.app.setMSMMode(false);

		window.app.content_area.current.switch_content.current.handleHideBottomMenu();
		window.app.content_area.current.content_handler('Login_Page');
	}

	loginStatus(is_logged_in) {
		super.loginStatus(is_logged_in);
		if (is_logged_in) {
			// Save the logged in status in local storage
			// this is used for auto login
			let controller_name = this.active_controller.name;
			let controller_info = JSON.parse(window.localStorage.getItem(controller_name));
			if (controller_info != null && controller_info != undefined) {
				controller_info.is_logged_in = true;
				controller_info.version = this.active_controller.version;
			}
			window.localStorage.setItem(controller_name, JSON.stringify(controller_info));
			// remove is_from_login_page after login
			if (this.stored_params.is_from_login_page != null) this.stored_params = {};
		}

		if (this.is_using_reconnection && is_logged_in) {
			// If reconnection successful 
			if (this.active_controller.model == 'F10' && window.app.state.is_msm_mode) {
				//  MSM
				this.next_component = 'MSM';
				this.getMSMSiteList();
			} else {
				this.getPointList();
			}
		} else if (this.active_controller.model == 'F10') {
			this.next_component = 'MSM';
			this.getMSMSiteList();
		} else if (is_logged_in) {
			this.next_component = 'Dashboard';
			this.getGroups();
		} else {
			window.app.onLogin(false);
		}
	}

	findController() {
		// For Comm Module to keep track if controller is found during reconnection
		this.reconnect_controller_found = false;
		// console.log('finding controller...')
		window.app.content_area.current.switch_content.current.setState({ controller_list: [] }, () => {
			super.findController();
		});
	}

	// Receive cos of management point
	cos(cos_info) {
		//console.log('cos_info = ' + JSON.stringify(cos_info));
		window.app.cos(cos_info);
	}

	error(error) {
		console.log('error.message = ' + error.message);
		//console.log('error.id = ' + error.id);
		switch (error.id) {
			case 103:
				if (this.existing_login_error == 'wrong_acc_or_pw') {
					window.app.hideLoading();
					this.active_controller.comm_module.socket_status = 'disconnect';
					this.active_controller.comm_module.cloud_status = 'disconnect';
					if (this.stored_params.is_from_login_page) {
						// If in login Page
						window.app.showToast(this.getString('wrong_acc_or_pw'), 3000);
						window.app.content_area.current.switch_content.current.ref.current.setState({ login_status: this.getString('wrong_acc_or_pw') })
					} else {
						// redirect to login page if acct name or password is wrong
						this.is_using_reconnection = false;
						window.app.content_area.current.content_handler('Login_Page', { is_from_error: true });
					}
				}
				break;
			case 104:
				window.app.hideLoading();
				window.app.showToast(this.getString('no_active_controller'), 3000);
				break;
			case 105:
				if (this.existing_login_error == 'block_period') {
					window.app.hideLoading();
					this.active_controller.comm_module.socket_status = 'disconnect';
					this.active_controller.comm_module.cloud_status = 'disconnect';
					if (this.stored_params.is_from_login_page) {
						// If in login Page
						window.app.showToast(this.getString('block_period'), 3000);
						window.app.content_area.current.switch_content.current.ref.current.setState({ login_status: this.getString('block_period') })
					} else {
						// redirect to login page if acct name or password is wrong
						this.is_using_reconnection = false;
						window.app.content_area.current.content_handler('Login_Page', { is_from_error: true });
					}
				}
				break;
			case 505:
				if (this.existing_login_error == '') {
					window.app.hideLoading();
					this.existing_login_error = 'Login Timeout';
					window.app.showToast(this.getString('login_timeout'), 3000);

					if (!this.stored_params.is_from_login_page) {
						this.is_using_reconnection = false;
						window.app.content_area.current.content_handler('Login_Page', { is_from_error: true });
					} else {
						this.active_controller.comm_module.socket_status = 'disconnect';
						this.active_controller.comm_module.cloud_status = 'disconnect';
						window.app.content_area.current.switch_content.current.ref.current.setState({ login_status: this.getString('login_timeout') })
					}
				}
				break;
			case 506:
				if (this.active_controller.is_logged_in) {
					this.is_using_reconnection = true;
					if (window.app != null) window.app.showLoading();
				}
				break;
			case 507:
				if (this.stored_params.is_from_login_page) {
					// If in login Page
					// CommModule connection state Case 9
					// console.log('Case 9 Connect Local...');
					this.active_controller.comm_module.socket_status = 'disconnect';
					this.active_controller.comm_module.cloud_status = 'disconnect';
					this.active_controller.comm_module.ctrl_login_status = 'logout';
					this.active_controller.comm_module.createWS();
				} else {
					// CommModule connection state Case 15
					// console.log('Case 15 Connect Local...');
					this.active_controller.comm_module.socket_status = 'disconnect';
					this.active_controller.comm_module.cloud_status = 'disconnect';
					this.active_controller.comm_module.ctrl_login_status = 'logout';
					this.active_controller.comm_module.createWS();
				}
				break;
			case 508:
				// CommModule connection state Case 8
				// console.log('Case 8 Connect Local...');
				this.active_controller.comm_module.socket_status = 'disconnect';
				this.active_controller.comm_module.cloud_status = 'disconnect';
				this.active_controller.comm_module.ctrl_login_status = 'logout';
				this.active_controller.comm_module.createWS();
				break;
			case 601:
				if (this.active_controller.ssc_connect == null || this.active_controller.ssc_connect == undefined) {
					window.app.hideLoading();
					window.app.showToast(this.getString('first_login_ssc'), 3000);
				} else {
					console.log(this.getString('ws_time_out'));
				}
				break;
			default:
		}
	}

	rcvPointList(point_list) {
		window.app.setState({ point_list: point_list });

		if (this.is_using_reconnection) {
			window.app.hideLoading();
			this.is_using_reconnection = false;
		} else if (this.next_component == 'Dashboard_With_Swipe') {
			// Already logged in and navigate to dashboard
			this.next_component = '';
			redirectToDashboardScreen(this.stored_params);
			this.stored_params = {};
		} else if (this.active_controller.is_logged_in) {
			if (this.active_controller.model == 'F10') {
				if (this.active_controller.active_site == '') {
					return;
				} else {
					window.app.content_area.current.switch_content.current.ref.current.rcvPointList(this.stored_params)
				}
			} else {
				this.next_component = '';
				window.app.onLogin(true, this.stored_params);
				this.stored_params = {};
			}
		}
	}

	rcvTime(time_info) {
		let year = parseInt(time_info.date.substring(0, 4));
		let month = parseInt(time_info.date.substring(4, 6));
		let date = parseInt(time_info.date.substring(6, 8));
		let hour = parseInt(time_info.time.substring(0, 2));
		let min = parseInt(time_info.time.substring(2, 4));

		let new_timestamp = new Date();
		new_timestamp.setYear(year);
		new_timestamp.setMonth(month - 1);
		new_timestamp.setDate(date);
		new_timestamp.setHours(hour);
		new_timestamp.setMinutes(min);

		window.app.setState({ timestamp: new_timestamp })
	}

	rcvFoundController(controller_info) {
		if (this.app_model == 'H') {
			if (!this.allowed_models.home.includes(controller_info.model)) {
				return;
			}
		} else if (this.app_model == 'F') {
			if (!this.allowed_models.office.includes(controller_info.model)) {
				return;
			}
		} else {
			return;
		}

		controller_info.is_available = true;

		if (this.stored_params.is_from_login_page) {
			// When in login page
			// During login, if ssc_connect is false and controller's IP Address is changed, 
			// check for existng controller with the same mac address in the network
			// then update the ip address.
			let controller_list = this.stored_params.controller_list;

			if (!isEmpty(controller_list)) {
				for (let list_item of controller_list) {
					if (list_item.mac_addr == controller_info.mac_addr) {
						return;
					}
				}
			} else {
				controller_list = [];
			}

			controller_list.push(controller_info);
			this.stored_params.controller_list = controller_list;
		} else if (this.stored_params.is_from_find_controller_page) {
			// When in Find Controller page
			window.app.content_area.current.switch_content.current.ref.current.rcvFoundController(controller_info);
		} else {
			// When after logged in
			if (this.active_controller.mac_addr == controller_info.mac_addr) {
				// set reconnect_controller_found to true so that commModuleControllerNotFound will not try to reconnect
				this.reconnect_controller_found = true;
				this.active_controller.ip_addr = controller_info.ip_addr;
				// Update existing controller info
				let existing_controller_info = JSON.parse(window.localStorage.getItem(this.active_controller.name));
				existing_controller_info.ip_addr = controller_info.ip_addr;
				window.localStorage.setItem(this.active_controller.name, JSON.stringify(existing_controller_info));
				// Create Local connection
				this.active_controller.comm_module.createWS();
				// For case 3/6
				this.active_controller.comm_module.is_looping_find_controller = false;
			}
		}
	}

	commModuleControllerNotFound = () => {
		// During reconnection if Comm module is unable to connect to cloud or LAN, 
		// It will try to find the controller within the network
		// after timeout 2sec it will call this function
		// i.e. case 4 and case 7 

		// If no controller is found
		if (!this.reconnect_controller_found) {
			console.log('No controller found')
			// For case 3/6
			this.active_controller.comm_module.is_looping_find_controller = false;
			if (this.active_controller.ssc_connect) {
				if (this.stored_params.is_from_login_page) {
					// CommModule connection state Case 12
					this.onWSConnectionFailed();
				} else {
					// console.log('Case 4 Connect SSC...');
					// CommModule connection state Case 4
					this.active_controller.comm_module.createWSS();
				}
			} else {
				if (this.stored_params.is_from_login_page) {
					// CommModule connection state Case 12
					this.onWSConnectionFailed();
				} else {
					// CommModule connection state Case 7
					// console.log('Case 7 Find Controller...');
					setTimeout(this.commModuleControllerNotFound, 2000);
					this.findController();
				}
			}
		}
	}

	getScene = () => {
		// Check available functions and if scene not available, do not getScene
		let is_scene_available = false;
		if (!isEmpty(this.active_controller.available_functions)) {
			if (this.active_controller.available_functions.scene) {
				is_scene_available = true;
				super.getScene();
			}
		}
		if (!is_scene_available) {
			// If scene not available, call rcvScene but pass empty {} as response 
			this.rcvScene({});
		}
	}

	onWSConnectionFailed = () => {
		// Go to login screen
		window.app.hideLoading();
		this.is_using_reconnection = false;
		window.app.showToast(this.getString('sock_err'), 3000, 80);
		if (this.active_controller.comm_module.socket_status == 'connect') {
			this.active_controller.comm_module.socket_status = 'disconnect';
			window.app.content_area.current.switch_content.current.handleHideBottomMenu();
			window.app.content_area.current.content_handler('Login_Page');
		} else {
			this.active_controller.comm_module.socket_status = 'disconnect';
			window.app.content_area.current.switch_content.current.ref.current.setState({ login_status: this.getString('ws_err') });
		}
	}

	rcvSysInfo(sys_info) {
		let controller_info = window.localStorage.getItem(this.active_controller.name) == null ? {} : JSON.parse(window.localStorage.getItem(this.active_controller.name));
		controller_info.model = sys_info.model;
		controller_info.version = sys_info.ver;
		controller_info.region = sys_info.region;
		controller_info.country = sys_info.country;
		controller_info.ssc_connect = sys_info.ssc;
		controller_info.ssc_url = sys_info.url;
		controller_info.mac_addr = sys_info.macaddr;

		window.localStorage.setItem(this.active_controller.name, JSON.stringify(controller_info));

		super.rcvSysInfo(sys_info);
		if (this.pending_login) {
			this.login(this.pending_login_user);
		}
	}

	rcvHwkey(hwkey) {
		let controller_info = window.localStorage.getItem(this.active_controller.name) == null ? {} : JSON.parse(window.localStorage.getItem(this.active_controller.name));
		controller_info.hwkey = hwkey;
		window.localStorage.setItem(this.active_controller.name, JSON.stringify(controller_info));
	}

	rcvSaveHolidayCalendar(holiday_info) {
		window.app.content_area.current.switch_content.current.ref.current.rcvSaveHolidayCalendar(holiday_info);
	}

	rcvLoadHolidayCalendar(holiday_info) {
		window.app.content_area.current.switch_content.current.ref.current.rcvLoadHolidayCalendar(holiday_info);
	}

	rcvGetBillData(bill_data) {
		window.app.content_area.current.switch_content.current.ref.current.rcvGetBillData(bill_data);
	}

	rcvLoadPPDPointList(ppd_point_list) {
		window.app.content_area.current.switch_content.current.ref.current.rcvLoadPPDPointList(ppd_point_list);
	}

	rcvGetPPD(response) {
		window.app.content_area.current.switch_content.current.ref.current.rcvGetPPD(response);
	}

	rcvLoadOwnerInfo(owner_info) {
		window.app.content_area.current.switch_content.current.ref.current.rcvLoadOwnerInfo(owner_info);
	}

	rcvSaveOwnerInfo(response) {
		window.app.content_area.current.switch_content.current.ref.current.rcvSaveOwnerInfo(response);
	}

	rcvLoadTenant(tenant_info) {
		window.app.content_area.current.switch_content.current.ref.current.rcvLoadTenant(tenant_info);
	}

	rcvSaveTenant(response) {
		window.app.content_area.current.switch_content.current.ref.current.rcvSaveTenant(response);
	}

	rcvLoadPriceInfo(response) {
		window.app.content_area.current.switch_content.current.ref.current.rcvLoadPriceInfo(response);
	}

	rcvSavePriceInfo(response) {
		window.app.content_area.current.switch_content.current.ref.current.rcvSavePriceInfo(response);
	}

	rcvGroups(groups) {
		switch (this.next_component) {
			case 'Dashboard':
			case 'Dashboard_With_Swipe':
				this.stored_params.groups = groups;
				this.getScene();
				break;
			case 'Interlock':
			case 'Schedule':
			case 'Add_Edit_Schedule_Home':
			case 'Schedule_Step3_Pattern':
			case 'Schedule_Step4_Execute_Days':
				this.stored_params.groups = groups;
				window.app.content_area.current.switch_content.current.handleShowBottomControls();
				window.app.content_area.current.content_handler(this.next_component, this.stored_params);
				this.next_component = '';
				this.stored_params = {};
				break;
			case 'Layout':
			case 'Layout_Editor':
				this.stored_params.groups = groups;
				this.getScene();
				break;
			default:
				if (this.active_controller.model == 'F10' && this.active_controller.active_site == '') {
					return;
				} else {
					redirectToGroupScreen(groups);
				}

		}
	}

	rcvAddGroup(response) {
		window.app.content_area.current.switch_content.current.ref.current.rcvAddGroupResponse(response);
	}

	rcvModifyGroup(response) {
		window.app.content_area.current.switch_content.current.ref.current.rcvModifyGroupResponse(response);
	}

	rcvDeleteGroup(response) {
		window.app.content_area.current.switch_content.current.ref.current.rcvDeleteGroupResponse(response);
	}

	rcvScene(response) {
		switch (this.next_component) {
			case 'Dashboard':
			case 'Dashboard_With_Swipe':
				this.stored_params.scenes = response;
				this.getPointList();
				break;
			case 'Scenes':
				redirectToScenesScreen(response);
				this.stored_params = {};
				this.next_component = '';
				break;
			case 'Add_Edit_Schedule_Home':
			case 'Schedule':
			case 'Schedule_Step3_Pattern':
			case 'Schedule_Step4_Execute_Days':
			case 'Interlock':
				this.stored_params.scenes = response;
				this.getInterlock();
				break;
			case 'Layout':
			case 'Layout_Editor':
				this.stored_params.scenes = response;
				this.readJSONFile({ name: 'layout_list.json' });
				break;
			default:
				if (this.active_controller.model == 'F10' && this.active_controller.active_site == '') {
					return;
				} else {
					window.app.content_area.current.switch_content.current.handleShowBottomControls();;
					window.app.content_area.current.content_handler(this.next_component, { scenes: response, from: this.stored_params.from });
					this.stored_params = {};
					this.next_component = '';
				}

		}
	}

	rcvAddScene(response) {
		window.app.content_area.current.switch_content.current.ref.current.rcvAddScene(response);
	}

	rcvModifyScene(response) {
		window.app.content_area.current.switch_content.current.ref.current.rcvModifyScene(response);
	}

	rcvDeleteScene(response) {
		window.app.content_area.current.switch_content.current.ref.current.rcvDeleteScene(response);
	}

	rcvExecuteScene(response) {
		window.app.content_area.current.switch_content.current.ref.current.rcvExecuteScene(response);
	}

	rcvSchedule(response) {
		// Tommy - 24/06/2021 - added Add_Edit_Schedule_Home component
		if (this.next_component == 'Interlock' || this.next_component == 'Schedule' || this.next_component == 'Schedule_Step3_Pattern'
			|| this.next_component == 'Schedule_Step4_Execute_Days' || this.next_component == 'Add_Edit_Schedule_Home') {
			this.stored_params.schedule = response;
			this.getGroups();
		}
	}

	rcvAddScheduleProgram(response) {
		window.app.content_area.current.switch_content.current.ref.current.rcvAddScheduleProgram(response);
	}

	rcvModifyScheduleProgram(response) {
		window.app.content_area.current.switch_content.current.ref.current.rcvModifyScheduleProgram(response);
	}

	rcvEnableScheduleProgram(response) {
		window.app.content_area.current.switch_content.current.ref.current.rcvEnableScheduleProgram(response);
	}

	rcvDeleteScheduleProgram(response) {
		window.app.content_area.current.switch_content.current.ref.current.rcvDeleteScheduleProgram(response);
	}

	rcvAddPattern(response) {
		// Get the current app model
		if (this.app_model == 'H') {
			let pattern_id = Object.keys(response)[0];
			// Tommy - 24/06/2021 - Changed from [] to this.stored_params.exec_cal
			this.stored_params.program.action[pattern_id] = { 'exec_dow': this.stored_params.dow, 'exec_cal': this.stored_params.exec_cal };
			this.addScheduleProgram(this.stored_params.program);
			this.stored_params = {};
		} else if (this.app_model == 'F') {
			window.app.content_area.current.switch_content.current.ref.current.rcvAddPattern(response);
		}
	}

	rcvModifyPattern(response) {
		window.app.content_area.current.switch_content.current.ref.current.rcvModifyPattern(response);
	}

	rcvDeletePattern(response) {
		window.app.content_area.current.switch_content.current.ref.current.rcvDeletePattern(response);
	}

	rcvAddCalendar(response) {
		window.app.content_area.current.switch_content.current.ref.current.rcvAddCalendar(response);
	}

	rcvModifyCalendar(response) {
		window.app.content_area.current.switch_content.current.ref.current.rcvModifyCalendar(response);
	}

	rcvDeleteCalendar(response) {
		window.app.content_area.current.switch_content.current.ref.current.rcvDeleteCalendar(response);
	}

	rcvInterlock(response) {
		this.stored_params.interlock = response;
		this.getSchedule();
	}

	rcvAddInterlockProgram(response) {
		window.app.content_area.current.switch_content.current.ref.current.rcvAddInterlockProgram(response);
	}

	rcvModifyInterlockProgram(response) {
		window.app.content_area.current.switch_content.current.ref.current.rcvModifyInterlockProgram(response);
	}

	rcvEnableInterlockProgram(response) {
		window.app.content_area.current.switch_content.current.ref.current.rcvEnableInterlockProgram(response);
	}

	rcvDeleteInterlockProgram(response) {
		window.app.content_area.current.switch_content.current.ref.current.rcvDeleteInterlockProgram(response);
	}

	rcvAccounts(response) {
		window.app.content_area.current.switch_content.current.handleShowBottomControls();;
		if (response.error != null) {

		} else {
			window.app.content_area.current.content_handler(this.next_component, { accounts: response });
		}
	}

	rcvAddAccount(response) {
		window.app.content_area.current.switch_content.current.ref.current.rcvAddAccount(response);
	}

	rcvModifyAccount(response) {
		window.app.content_area.current.switch_content.current.ref.current.rcvModifyAccount(response);
	}

	rcvDeleteAccount(response) {
		window.app.content_area.current.switch_content.current.ref.current.rcvDeleteAccount(response);
	}

	rcvChangePassword(response) {
		window.app.content_area.current.switch_content.current.ref.current.rcvChangePassword(response);
	}

	rcvSetPointSettings(response) {
		window.app.content_area.current.switch_content.current.ref.current.rcvSetPointSettings(response);
	}

	rcvExec(response) {
		window.app.content_area.current.switch_content.current.ref.current.rcvExec(response);
	}

	rcvChangeoverGroups(response) {
		window.app.content_area.current.switch_content.current.handleShowBottomControls();
		window.app.content_area.current.content_handler('Changeover', { changeover_groups: response });
	}

	rcvAddChangeover(response) {
		window.app.content_area.current.switch_content.current.ref.current.rcvAddChangeover(response);
	}

	rcvModifyChangeover(response) {
		window.app.content_area.current.switch_content.current.ref.current.rcvModifyChangeover(response);
	}

	rcvDeleteChangeover(response) {
		window.app.content_area.current.switch_content.current.ref.current.rcvDeleteChangeover(response);
	}

	rcvEnableChangeover(response) {
		window.app.content_area.current.switch_content.current.ref.current.rcvEnableChangeover(response);
	}

	rcvHistory(response) {
		window.app.content_area.current.switch_content.current.ref.current.rcvHistory(response);
	}

	rcvTotalOpTime(response) {
		window.app.content_area.current.switch_content.current.ref.current.rcvTotalOpTime(response);
	}

	// Not Used
	/*rcvHourlyOpTime(response){
		window.app.content_area.current.switch_content.current.ref.current.rcvHourlyOpTime(response);
	}*/

	rcvOptimePointList(response) {
		window.app.content_area.current.switch_content.current.ref.current.rcvOptimePointList(response);
	}

	rcvDailyOpTime(response) {
		window.app.content_area.current.switch_content.current.ref.current.rcvDailyOpTime(response);
	}

	rcvMonthlyOpTime(response) {
		window.app.content_area.current.switch_content.current.ref.current.rcvMonthlyOpTime(response);
	}

	rcvDailyErrorInfo(response) {
		window.app.content_area.current.switch_content.current.ref.current.rcvDailyErrorInfo(response);
	}

	rcvMonthlyErrorInfo(response) {
		window.app.content_area.current.switch_content.current.ref.current.rcvMonthlyErrorInfo(response);
	}

	rcvMeterPointList(response) {
		window.app.content_area.current.switch_content.current.ref.current.rcvMeterPointList(response);
	}

	rcvHourlyMeter(response) {
		window.app.content_area.current.switch_content.current.ref.current.rcvHourlyMeter(response);
	}

	rcvDailyMeter(response) {
		window.app.content_area.current.switch_content.current.ref.current.rcvDailyMeter(response);
	}

	rcvMonthlyMeter(response) {
		window.app.content_area.current.switch_content.current.ref.current.rcvMonthlyMeter(response);
	}

	rcvTrendPointList(response) {
		window.app.content_area.current.switch_content.current.ref.current.rcvTrendPointList(response);
	}

	rcvTrendData(response) {
		window.app.content_area.current.switch_content.current.ref.current.rcvTrendData(response);
	}

	rcvRealtimeEnergy(response) {
		if (this.next_component == 'RT_Energy_View') {
			window.app.hideLoading();
			this.stored_params.data = response;
			window.app.content_area.current.content_handler(this.next_component, this.stored_params);
			this.next_component = '';
			this.stored_params = {};
		} else {
			if (window.app.content_area.current.switch_content.current.ref.current.rcvRealtimeEnergy != null) {
				window.app.content_area.current.switch_content.current.ref.current.rcvRealtimeEnergy(response);
			}
		}
	}

	rcvRealtimeEnergyCos(response) {
		if (window.app.content_area.current.switch_content.current.ref.current.rcvRealtimeEnergyCos != null) {
			window.app.content_area.current.switch_content.current.ref.current.rcvRealtimeEnergyCos(response);
		}
	}

	rcvReadJSONFile(response) {
		if (response.name == 'functions.json' && this.active_controller.model == 'F10') {
			window.app.content_area.current.switch_content.current.ref.current.rcvReadJSONFile(response);
			return;
		}

		let data = {};

		switch (this.next_component) {
			case 'Layout':
			case 'Layout_Editor':
				this.stored_params.layouts = response.data;

				if (this.next_component == 'Layout_Editor') window.app.content_area.current.switch_content.current.handleShowBottomControls();

				window.app.hideLoading();
				window.app.content_area.current.content_handler(this.next_component, this.stored_params);
				this.next_component = '';
				this.stored_params = {};
				break;
			case 'RT_Energy_View':
				this.stored_params.layout = response.data
				super.loadReportSettings();
				break;
			case 'IAQ_Monitoring':
				this.stored_params.iaq_monitoring_settings = response.data
				window.app.content_area.current.switch_content.current.handleShowBottomMenu();
				window.app.content_area.current.content_handler(this.next_component, this.stored_params);
				this.next_component = '';
				this.stored_params = {};
				window.app.hideLoading();
				break;
			case 'Guest_Room_Overview':
				this.next_component = '';
				this.stored_params.guest_room_settings = response.data;
				redirectToGuestRoomScreen(this.stored_params);
				this.stored_params = {};
				break;
			case 'Guest_Room_Settings':
				this.next_component = '';
				this.stored_params.guest_room_settings = response.data;
				window.app.content_area.current.content_handler('Guest_Room_Settings', this.stored_params);
				this.stored_params = {};
				break;
			case 'MSM_Settings_Regions':
				this.next_component = '';
				data = {};
				if (!isEmpty(response.data)) data = response.data;
				window.app.content_area.current.content_handler('MSM_Settings_Regions', { msm_region_settings: data });
				break;
			case 'MSM':
				this.next_component = '';
				data = {};
				if (!isEmpty(response.data)) data = response.data;
				window.app.content_area.current.switch_content.current.handleShowBottomMenu();
				window.app.content_area.current.content_handler('MSM', { msm_region_settings: data });
				break;
			default:
				window.app.content_area.current.switch_content.current.ref.current.rcvReadJSONFile(response);
		}
	}

	rcvSaveJSONFile(response) {
		window.app.content_area.current.switch_content.current.ref.current.rcvSaveJSONFile(response);
	}

	rcvLoadImage(response) {
		window.app.content_area.current.switch_content.current.ref.current.rcvLoadImage(response);
	}

	rcvSaveImage(response) {
		window.app.content_area.current.switch_content.current.ref.current.rcvSaveImage(response);
	}

	rcvCheckUpdate(response) {
		window.app.content_area.current.switch_content.current.ref.current.rcvCheckUpdate(response);
	}

	rcvUpdateCommandSent(response) {
		window.app.content_area.current.switch_content.current.ref.current.rcvUpdateCommandSent(response);
	}

	rcvGuestRoomsData(response) {
		this.stored_params.guest_rooms = response;
		this.readJSONFile({ name: 'guest_room_settings.json' });
	}

	rcvSetRoomRental(response) {
		window.app.content_area.current.switch_content.current.ref.current.rcvSetRoomRental(response);
	}

	rcvGetControlParam(response) {
		window.app.content_area.current.switch_content.current.ref.current.rcvGetControlParam(response);
	}

	rcvSetControlParam(response) {
		window.app.content_area.current.switch_content.current.ref.current.rcvSetControlParam(response);
	}

	rcvMSMSiteList(response) {
		if (this.next_component == 'MSM_Settings_Sites') {
			// Add or modify or delete site
			window.app.content_area.current.switch_content.current.handleHideBottomMenu();
			window.app.setState({ site_list: response })
			window.app.content_area.current.content_handler('MSM_Settings_Sites');
		} else if (this.next_component == 'MSM') {
			// MSM Dashboard
			window.app.setMSMMode(true);
			this.active_controller.setActiveSite('');
			window.app.setState({ site_list: response });
			this.readJSONFile({ name: 'msm_region_settings.json' });
		}
	}

	rcvMSMSiteStat(response) {
		window.app.rcvMSMSiteStat(response);
	}

	rcvMSMTempTargList(response) {
		window.app.content_area.current.switch_content.current.ref.current.rcvMSMTempTargList(response);
	}

	rcvMSMValTargList(response) {
		window.app.content_area.current.switch_content.current.ref.current.rcvMSMValTargList(response);
	}

	rcvMSMSiteInfo(response) {
		window.app.content_area.current.switch_content.current.ref.current.rcvMSMSiteInfo(response);
	}

	rcvMSMAddSite(response) {
		window.app.content_area.current.switch_content.current.ref.current.rcvMSMAddSite(response);
	}

	rcvMSMModifySite(response) {
		window.app.content_area.current.switch_content.current.ref.current.rcvMSMModifySite(response);
	}

	rcvMSMDeleteSite(response) {
		window.app.content_area.current.switch_content.current.ref.current.rcvMSMDeleteSite(response);
	}

	rcvLoadReportSettings(response) {
		let report_settings = {
			"start_month": 0,
			"start_day": 1,
			"categories": {
				"is_show_energy_categories": false,
				"is_energy_generator_enabled": false,
				"is_water_consumption_enabled": false,
				"is_recycled_water_enabled": false,
				"energy": {},
				"energy_generator": {
					"name": "energy_generator",
					"points": []
				},
				"water_consumption": {
					"name": "water_consumption",
					"points": []
				},
				"recycled_water": {
					"name": "recycled_water",
					"points": []
				}
			}
		}

		if (response.result == 'OK') {
			if (!isEmpty(response.data)) {
				Object.keys(response.data).map((key) => {
					report_settings[key] = response.data[key];
				})
			}
		}

		if (this.next_component == 'Reports') {
			this.next_component = '';
			redirectToReportScreen(report_settings);
		} else if (this.next_component == 'RT_Energy_View') {
			this.stored_params.report_settings = report_settings;
			super.getRealtimeEnergy();
		} else {
			window.app.content_area.current.switch_content.current.ref.current.rcvLoadReportSettings(report_settings);
		}
	}

	rcvSaveReportSettings(response) {
		window.app.content_area.current.switch_content.current.ref.current.rcvSaveReportSettings(response);
	}
}
